import { createFileRoute, Outlet } from "@tanstack/react-router";
import { PageContainer, PageHeader } from "@/components/layout/page";
import { PageTabs } from "@/components/nav/tabbed-page";

export const Route = createFileRoute("/_app/catalog")({
  component: CatalogLayout,
});

function CatalogLayout() {
  return (
    <PageContainer>
      <PageHeader
        title="Schema & Lineage"
        description="Registered schemas and how data flows between systems."
      />
      <PageTabs
        tabs={[
          { label: "Schemas", to: "/catalog/schemas" },
          { label: "Lineage", to: "/catalog/lineage" },
        ]}
      />
      <Outlet />
    </PageContainer>
  );
}
